import script from "./TableRowsHead.vue?vue&type=script&setup=true&lang=js"
export * from "./TableRowsHead.vue?vue&type=script&setup=true&lang=js"

import "./TableRowsHead.vue?vue&type=style&index=0&id=70f555ac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70f555ac"]])

export default __exports__